/* Dawnスライドコンポーネントの独自スクロールバーカスタマイズ */
function customSliderScrollbar() {
  // スライドターゲット
  const customSliders = document.querySelectorAll('.c-slider-scrollbar__active');

  // ページ内にスライダーが存在する場合は
  if(customSliders) {

    function customSliderScrollbarSet() {
      customSliders.forEach(function(slider){
        // customSliders内でループ処理
        // スライダーが非表示でなければ実行
        if (slider.offsetParent !== null) {
          // 変数格納
          let curentSlider = slider.querySelector('.c-slider'),
              slide = curentSlider.firstElementChild,
              slideNum = curentSlider.querySelectorAll('li').length;

          // ランキングセクションSP閲覧時は先頭スライドが非表示となるため再計算
          if (slide.offsetWidth <= 10) {
            slide = slide.nextElementSibling;
            slideNum = slideNum - 1;
          }
    
          // 数値計算
          let slideGap = parseInt(window.getComputedStyle(curentSlider).columnGap),
              slidePadding = parseInt(window.getComputedStyle(curentSlider, "::after").paddingLeft),
              scrollBar = slider.querySelector('.c-slider-nav'),
              scrollBarBody = scrollBar.querySelector('.c-slider-nav__bar--body'),
              scrollableWidth = parseInt(curentSlider.offsetWidth),
              adjustmentWidth = parseInt(slide.offsetWidth * slideNum + slideGap * slideNum + slidePadding);
          
          // ①ターゲットのラッパー要素と内部要素の幅を比較しスクロールバーの長さを指定
          let scrollBarWidth = (scrollableWidth / adjustmentWidth) * 100;
          scrollBarBody.style.width = scrollBarWidth + '%';

          // ②ターゲット内でスクロールが発生した場合に自作スクロールバーの表示位置を%で移動させる
          curentSlider.addEventListener('scroll', function(){
            let offset = curentSlider.scrollLeft,
                offsetPercentage = (offset / curentSlider.offsetWidth) * 100;
            scrollBarBody.style.left = offsetPercentage * (scrollableWidth / adjustmentWidth)  + '%';
          });
        }
      });
    }

    // 画面リサイズ時の再実行
    const resizeTarget = document.querySelector('#MainContent');
    const resizeObserver = new ResizeObserver(entries => {
      customSliderScrollbarSet();
    });
    
    resizeObserver.observe(resizeTarget);
  }

}

customSliderScrollbar();